<template>
    <q-layout view="lhr lpr lfr">
        <q-header elevated>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
                <template #customer-logo>
                    <div  class="customer-logo" style="width:25em; font-family:monospace; color:#fff !important" >
                        <q-input label-color="white" filled inverted readonly v-model="activeCaseId" @click="$event.target.select()" label="Case Id" class="gfk-bg-primary gfk-q-input" ></q-input>
                    </div>
                </template>
            </gfk-header>
        </q-header>

        <q-page-container>
            <div class="row xs-gutter">
                <div class="col-lg-12" style="width: 100%;">
                    <q-card class="bg-white no-margin">
                        <q-card-section>
                            <div class="row items-center sm-gutter">
                                <div class="no-wrap col">
                                    <q-tabs v-model="tab" align="left" class="IDtabs gfk-bg-primary text-white shadow-2">
                                        <template v-for="sys in searchResultSystems">
                                            <q-tab :name="sys" :label="sys">
                                                <q-badge color="red" floating>{{ selectedSearchResults[sys].length }}</q-badge>
                                            </q-tab>
                                        </template>
                                    </q-tabs>
                                    <q-separator/>
                                    <template v-for="sys in searchResultSystems">
                                        <q-tab-panels v-model="tab">
                                            <q-tab-panel :name="sys">
                                                <div class="row justify-end">
                                                    <q-btn color="blue-10" class="col-2 q-mt-md q-mb-md" label="Select All" @click="selectAll(sys)" />
                                                </div>
                                                <template v-for="record in selectedSearchResults[sys]">
                                                    <div class="row no-wrap">
                                                        <em>Record:</em>&nbsp;<strong>{{ record.systemIdentifier }} </strong>
                                                        <template v-if="false">(altered)</template>
                                                    </div>
                                                    <div class="no-wrap">
                                                        <q-table table-class="modification-table" :bordered=false :columns="columns" :rows="record.data">
                                                            <q-tr slot="header" slot-scope="props" :props="props" alig>
                                                                <q-th class="q-table-th text-center" v-for="col in props.cols" :key="col.name" :props="props">
                                                                    <div class="text-center">{{ col.label }}</div>
                                                                </q-th>
                                                            </q-tr>
                                                            <template v-slot:body-cell-delete="cell">
                                                                <q-td  :props="cell">
                                                                    <q-checkbox
                                                                        :color="conflicts[tableKey(sys, record.id, cell.row.idx)] ? 'red' : 'primary'"
                                                                        v-model="selectedForDelete"
                                                                        :val="tableKey(sys, record.id, cell.row.idx)" />
                                                                </q-td>
                                                            </template>
                                                            <template v-slot:body-cell-modify="cell">
                                                                <q-td :props="cell">
                                                                    <q-field borderless>
                                                                        <div class="row no-wrap">
                                                                            <q-checkbox
                                                                                :color="(conflicts[tableKey(sys, record.id, cell.row.idx)] || !selectedForModifyChanges[tableKey(sys, record.id, cell.row.idx)]) ? 'red' : 'primary'"
                                                                                v-model="selectedForModify"
                                                                                :val="tableKey(sys, record.id, cell.row.idx)" />
                                                                            <div
                                                                                :class="selectedForModifyMap[tableKey(sys, record.id, cell.row.idx)] ? 'visible' : 'invisible'">
                                                                                <q-input placeholder="New Value"
                                                                                    v-model="selectedForModifyChanges[tableKey(sys, record.id, cell.row.idx)]" />
                                                                            </div>
                                                                        </div>
                                                                    </q-field>
                                                                </q-td>
                                                            </template>
                                                            <template v-slot:body-cell-report="cell">
                                                                <q-td :props="cell">
                                                                    <q-checkbox v-model="selectedForReport"
                                                                        :val="sys + '|' + record.id + '|' + cell.row.idx" />
                                                                </q-td>
                                                            </template>
                                                        </q-table>
                                                    </div>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <h4>
                                                    <a :href="generateReportDownloadLink(sys)"
                                                        :download="`user-report-${activeCaseId}.json`"
                                                        class="q-btn-rectangle rounded-borders q-btn row inline flex-center q-focusable q-hoverable relative-position items-center q-btn-large gfk-bg-primary text-white">
                                                        <div class="desktop-only q-focus-helper"></div> <!----> <span
                                                            class="q-btn-inner row col flex-center"><!---->Report
                                                            {{ sys }}<!----></span>
                                                    </a>
                                                    <q-btn :disable="hasConflicts || nothingSelected || emptyModifications"
                                                        class="gfk-bg-primary rounded-borders text-white q-ma-sm" large @click="remediate(sys)">Request remediation
                                                        {{ sys }}</q-btn>
                                                </h4>
                                            </q-tab-panel>
                                        </q-tab-panels>
                                    </template>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
        </q-page-container>
        <q-footer>
            <gfk-footer />
        </q-footer>
        <template>
            <div class="q-pa-md q-gutter-sm">
                <q-dialog v-model="opened" :content-css="{ minHeight: '50vh', minWidth: '45vw' }">
                    <q-card v-if="!this.permalinkOpened">
                        <q-card-section elevated class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar  >
                                <q-toolbar-title>Confirms</q-toolbar-title>
                            </q-toolbar>
                        </q-card-section>
                        <q-card-section style="max-height: 50vh" class="scroll">
                            <div class="layout-padding justify-center">
                                <div>
                                    <p class="caption">
                                        You are going to request the following SYSTEM MODIFICATIONS:
                                    </p>
                                    
                                    <q-tabs align="justify" v-model="dialogTab" class="gfk-bg-primary text-white">
                                        <q-tab name="formatted" :default="true">Formatted</q-tab>
                                        <q-tab  name="raw">RAW JSON</q-tab>
                                    </q-tabs>
                                    <q-separator/>
                                    <q-tab-panels v-model="dialogTab">
                                        <q-tab-panel name="formatted">
                                            <formatted-request :records="requestPayload" />
                                        </q-tab-panel>
                                        <q-tab-panel name="raw">
                                            <div class="row wrap">
                                                <pre>{{ JSON.stringify(requestPayload, null, ' ') }}</pre>
                                            </div>
                                        </q-tab-panel>
                                    </q-tab-panels>
                                </div>
                            </div>
                        </q-card-section>
                        <q-card-section elevated class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar slot="footer">
                                <div class="row no-wrap justify-between full-width">
                                    <div class="col-xs-4 col-md-3 col-lg-2">
                                        <q-btn flat @click="opened = false" label="Go back" />
                                    </div>
                                    <div class="col-xs-4 col-md-3 col-lg-2">
                                        <q-btn @click="createRemediation" flat label="Proceed" />
                                    </div>
                                </div>
                            </q-toolbar>
                        </q-card-section>
                    </q-card>
                    <q-card v-if="this.permalinkOpened">
                        <q-card-section v-if="this.permalinkOpened" elevated class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar  >
                                <q-toolbar-title>Remediation permalink</q-toolbar-title>
                            </q-toolbar>
                        </q-card-section>
                        <q-card-section v-if="this.permalinkOpened" style="min-height: 50vh; min-width:43.5vw" class="scroll">
                            <div class="layout-padding justify-center">
                                <router-link :to="{ name: 'permalinkView', params: { id: remediationId } }">Permalink</router-link>
                            </div>
                        </q-card-section>
                        <q-card-section v-if="this.permalinkOpened" elevated class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar >
                                <div class="col-xs-4 col-md-3 col-lg-2">
                                    <q-btn flat @click="opened = false" class="text-white" label="Close" />
                                </div>
                            </q-toolbar>
                        </q-card-section>
                    </q-card>
                </q-dialog>
            </div>
        </template>
    </q-layout>
</template>

<script>
import {
    QLayout, QToolbar, QToolbarTitle, QSelect, QInnerLoading, QSpinnerGears, QCard, QTab, QTabs, QBtn, QCheckbox, QInput, QField, QPageContainer, QFooter, QTd, QTh, QTr, QCardSection, QTabPanels, QTabPanel, QDialog, QHeader, QBadge, QSeparator, QSpace
} from 'quasar';

import authenticateApi from '../api/auth';
import remediationApi from '../api/remediation';
import { ref } from 'vue'
import store from '../store';
import {
    CASEID,
    SEARCH_RESULTS_TABLE,
    ACTIVE_SEARCH_ID
} from '../store/keys';

import gfkHeader from './gfk-header.vue';
import gfkFooter from './gfk-footer.vue';
import siteData from '../mixins/site-data-mixin';
import RecordTable from './record-table.vue';
import FormattedRequest from './formatted-request.vue';
import searchSelectionStore from '../store/searchSelection';

const extractIdentifier = (row) => {
    const rId = row.location.recordId;
    if (_.isArray(rId)) {
        return _.map(rId, (k) => k + ' : ' + (_.has(row.rowData, k) ? row.rowData[k] : null)).join(' ');
    }
    return `${rId}:${_.has(row.rowData, rId) ? row.rowData[rId] : null}`;
};

const concatCustomizer = (objValue, srcValue) => {
    if (_.isArray(objValue)) {
        return objValue.concat(srcValue);
    }
};

/**
 * Extract the selection of variable strings into operation objects.
 * @remark The Quasar model forces us to use a string formed as <system>|<recordIndex>|<variableIndex>.
 * @param system - system to filter on
 * @param selectedArray - the selected operations array, as bound in Vue
 * @param opsMapper - generate additional metadata for the operation, given the record itself
 * @return {Object} - an object with record indexes as keys, and object values containing at minimum varIdx,
 *                      as well as whatever opsMapper returns
 */
const extractSelection = (system, selectedArray, opsMapper) => {
    const exploded = _.map(selectedArray, (v) => v.split('|'));
    // exploded now contains tuples of [system, recordIndex, variableIndex]
    // eslint-disable-next-line comma-spacing
    const selectedVariables = _.filter(exploded, ([sys, ,]) => sys === system);
    // eslint-disable-next-line comma-spacing,comma-dangle
    const groupedVariablesByRecord = _.groupBy(selectedVariables, ([, recordIdx,]) => recordIdx);
    return _.mapValues(groupedVariablesByRecord, (records) => _.map(records, (record) => {
        const [, , varIdx] = record;
        return { varIdx, ...opsMapper(record) };
    }));
};

/**
 * Create an object designed to return an indexed name in case of duplicates. To be used while reporting,
 * because the same PII category can be present in multiple places at once
 * @returns [Function] - an indexed name generator
 * @remark - the first time the generator is invoked, the category "cat" is not changed. Then, it returns
 * 		 "cat_2", "cat_3", etc.
 */
const makeDuplicateIndexer = () => {
    const categoriesIndexed = {};
    return (category) => {
        if (categoriesIndexed[category]) {
            const lastIndex = categoriesIndexed[category];
            categoriesIndexed[category] += 1;
            return `${category}_${lastIndex}`;
        }
        categoriesIndexed[category] = 2;
        return category;
    };
};

const extractEmailAddress = (record) => {
    const emailEntry = record.data.find(item => item.category === 'email');
    return emailEntry ? emailEntry.value : null;
};

export default {
    setup:()=>{
        return {
            tab: ref(''),
            dialogTab: ref('formatted')
        }
        
    },
    mixins: [siteData],
    components: {
        FormattedRequest,
        RecordTable,
        QLayout,
        QToolbar,
        QToolbarTitle,
        gfkHeader,
        gfkFooter,
        QSelect,
        QInnerLoading,
        QSpinnerGears,
        QCard,
        QCardSection,
        QTab,
        QTabs,
        QTabPanels,
        QTabPanel,
        QBtn,
        QCheckbox,
        QInput,
        QField,
        QDialog,
        QLayout,
        QHeader,
        QPageContainer,
        QFooter,
        QTd,
        QTh,
        QTr,
        QBadge,
        QSeparator,
        QSpace
    },
    data() {
        return {
            test: ['1', '2', '3'],
            columns: [
                {
                    label: 'Variable',
                    field: 'variable',
                    name: 'variable'
                },
                {
                    label: 'Category',
                    field: 'category',
                    name: 'category'
                },
                {
                    label: 'Value',
                    field: 'value',
                    name: 'value'
                },
                {
                    label: 'Delete',
                    field: 'delete',
                    name: 'delete'
                },
                {
                    label: 'Modify',
                    field: 'modify',
                    name: 'modify'
                },
                {
                    label: 'Report',
                    field: 'report',
                    name: 'report'
                }
            ],
            selectedForDelete: [],
            selectedForModify: [],
            selectedForModifyChanges: {},
            selectedForReport: [],
            requestPayload: [],
            opened: false,
            permalinkOpened: false,
            remediationId: '',
            remediationPermalink: ''
        };
    },
    mounted() {
        this.selectedForReport = _.flatMap(
            this.searchResultSystems,
            (sys) => _.flatMap(
                this.selectedSearchResults[sys],
                (rec) => _.map(rec.data, (variable) => {
                    return this.tableKey(sys, rec.id, variable.idx);
                })
            )
        );
    },
    methods: {
        selectAll(sys) {
                // Collect all checkbox values for the current system
                const allKeys = [];
                _.each(this.selectedSearchResults[sys], (record) => {
                    _.each(record.data, (variable) => {
                        allKeys.push(this.tableKey(sys, record.id, variable.idx));
                    });
                });
                
                // Set all checkboxes
                this.selectedForDelete = [...new Set([...this.selectedForDelete, ...allKeys])];
            },
        createRemediation() {
            const remediation = { caseId: this.activeCaseId, searchId: this.activeSearchId, remediation: this.requestPayload };
            remediationApi.create(remediation).then((data) => {
                this.remediationId = data.remediationId;
                const a = document.createElement('a');
                a.href = this.$router.resolve({ name: 'permalinkView', params: { id: this.remediationId } }).href;
                this.remediationPermalink = `${a.protocol}//${a.host}${a.pathname}${a.search}${a.hash}`;
                this.permalinkOpened = true;
            }).catch(console.error);
        },
        tableKey(system, recordId, variableIndex) {
            return `${system}|${recordId}|${variableIndex}`;
        },
        joinWithRecordData(sys, perRecordOps, opsProcessor, recordProcessor) {
            const finalRecords = [];
            _.forOwn(perRecordOps, (variableOps, recordIdx) => {
                const tableRecord = _.find(this.selectedSearchResults[sys], (r) => r.id.toString() === recordIdx.toString());
                const searchRecord = this.searchResults[recordIdx];
                const record = {
                    primaryKey: extractIdentifier(searchRecord),
                    emailAddress: extractEmailAddress(tableRecord)
                };
                _.merge(record, recordProcessor(searchRecord));
                _.each(variableOps, (op) => {
                    const { varIdx, ...rest } = op;
                    const recordData = tableRecord.data[varIdx];
                    _.merge(record, opsProcessor(rest, recordData));
                });
                finalRecords.push(record);
            });
            return finalRecords;
        },
        generateReportDownloadLink(sys) {
            return `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(this.reportData(sys)))}`;
        },
        remediate(sys) {
            this.permalinkOpened = false;
            if (_.isEmpty(_.intersection(this.selectedForModify, this.selectedForDelete))) {
                const selectedModificationChanges = extractSelection(
                    sys,
                    this.selectedForModify,
                    ([system, recordIdx, varIdx]) => (
                        {
                        op: 'modify',
                        param: this.selectedForModifyChanges[this.tableKey(system, recordIdx, varIdx)]
                        }
                    )
                );
                const selectedDeleteChanges = extractSelection(
                    sys,
                    this.selectedForDelete,
                    () => (
                        { op: 'nullify' }
                    )
                );
                const perRecordOps = _.mergeWith(selectedModificationChanges, selectedDeleteChanges, concatCustomizer);

                const finalRecords = this.joinWithRecordData(
                    sys,
                    perRecordOps,
                    (ops, recordData) => ({
                        operations: {
                            [recordData.variable]: ops
                        }
                    }),
                    (tableRecord) => {
                        const { searchColumns, targetColumns, ...rest } = tableRecord.location;

                        return {
                            location: rest
                        };
                    }
                );
                this.requestPayload = finalRecords;
                this.opened = true;
            } else {
                console.log('TODO: show alert explaining the intersection problem');
            }
        },
        reportData(sys) {
            const appsTable = searchSelectionStore.datasources; //this.$route.params.datasources;
            const selectedReporting = extractSelection(
                sys,
                this.selectedForReport,
                () => ({ op: 'report' })
            );

            let categoryIndexer = makeDuplicateIndexer();
            const finalRecords = this.joinWithRecordData(
                sys,
                selectedReporting,
                (ops, recordData) => ({
                    [categoryIndexer(recordData.category)]: recordData.value
                }),
                () => {
                    categoryIndexer = makeDuplicateIndexer();
                    return {};
                }
            );

            const d = new Date();
            const reportForSystem = {
                exportDate: `${d.toDateString()} ${d.toTimeString()}`,
                appId: appsTable[sys].appID,
                appName: appsTable[sys].displayName,
                records: finalRecords
            };
            return reportForSystem;
        }
    },
    computed: {
        selectedForModifyMap() {
            const retval = {};
            _.each(this.selectedForModify, (sel) => {
                retval[sel] = true;
            });
            return retval;
        },
        conflicts() {
            return _.keyBy(_.intersection(this.selectedForModify, this.selectedForDelete));
        },
        hasConflicts() {
            return !_.isEmpty(this.conflicts);
        },
        nothingSelected() {
            return _.isEmpty(this.selectedForDelete) && _.isEmpty(this.selectedForModify);
        },
        emptyModifications() {
            const trueModifications = {};
            _.each(this.selectedForModify, (selection) => {
                trueModifications[selection] = this.selectedForModifyChanges[selection];
            });
            return _.findKey(trueModifications, _.isEmpty) !== undefined;
        },
        userDisplayName() {
            return authenticateApi.getUsername();
        },
        activeCaseId() {
            return store.getters[CASEID];
        },
        activeSearchId() {
            return store.getters[ACTIVE_SEARCH_ID];
        },
        searchResultSystems() {
            return Object.keys(this.selectedSearchResults);
        },
        searchResults() {
            return store.getters[SEARCH_RESULTS_TABLE];
        },
        selectedSearchResults() {
            const makeCategoryLookup = (row) => {
                const lookup = {};
                _.each(row.location.targetColumns, (tgtCol) => {
                    lookup[tgtCol.name] = tgtCol.category;
                });
                return lookup;
            };
            const rowToTable = (row) => {
                const lookup = makeCategoryLookup(row);
                const inc = (() => {
                    let i = 0;
                    return () => {
                        const r = i;
                        i += 1;
                        return r;
                    };
                })();
                return _.chain(Object.keys(row.rowData))
                    .map((key) => ({
                        variable: key,
                        category: lookup[key],
                        value: row.rowData[key]
                    })).filter(r => !_.isEmpty(r.value))
                    .map((r) => ({
                        ...r,
                        idx: inc()
                    }))
                    .value();
            };

            const resultsPerSystem = _.chain(searchSelectionStore.recordIds)
                .map((idx) => this.searchResults[idx])
                .groupBy('location.sourceSystem')
                .mapValues((rows) => _.map(rows, (row) => ({
                    id: row.id,
                    systemIdentifier: extractIdentifier(row),
                    data: rowToTable(row)
                })))
                .value();

            console.log("resultsPerSystem",resultsPerSystem);
            
            return resultsPerSystem;


        }
    }
};
</script>
